// extracted by mini-css-extract-plugin
export default {"ScreenSMMin":"(min-width: 768px)","container":"G3ba228","boxSummary":"G8ab58d G3ba228"};